/*
 * File: catalog-list.component.ts                                             *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 22nd December 2021 12:48:17                        *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Thursday, 2nd March 2023 14:40:19                            *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';

import { CatalogService } from '../../../services/catalog.service';
// import { EsPaginatorIntl } from '../../../tms-tools/helpers/es-paginator-intl';
import { Catalog } from '@nousmedis/cc-types';
import { FascicleService } from '../../../services/fascicle.service';
import { Subscription } from 'rxjs';
//import { TreeNode } from 'primeng/api';
import { Router } from '@angular/router';


@Component({
  selector: 'app-catalog-list',
  templateUrl: './catalog-list.component.html',
  styleUrls: ['./catalog-list.component.scss'],
  providers: [],
})
export class CatalogListComponent implements OnInit, OnDestroy {


  //Data for table
  dataCatalog: any[] = [];
  filteredCatalogs: any[] = [];
  filterText = '';

  //if true table shows
  dataLoaded: boolean = false;

  //Subscriptions:
  fascicleSubscription: Subscription;
  dataLoadingSubscription: Subscription;
  dataSusbscription: Subscription;
  deleteCatalogSubs: Subscription;

  constructor (
    private router: Router,
    private catalogService: CatalogService,
    private fascicleService: FascicleService,
  ) { }


  ngOnDestroy(): void {
    this.fascicleSubscription.unsubscribe();
    this.dataLoadingSubscription.unsubscribe();
    this.dataSusbscription.unsubscribe();
  }

  ngOnInit(): void {
    this.subscribeToServices();
    this.catalogService.fetchCatalogList();
  }


  subscribeToServices() {
    //Subscribe to data loading
    this.dataLoadingSubscription = this.catalogService.dataLoading.subscribe(
      (loading) => {
        this.dataLoaded = loading;
      }
    );

    this.deleteCatalogSubs = this.catalogService.allDeleted.subscribe((data) => {
      this.catalogService.fetchCatalogList();
    });

    //Subscribe to data
    this.dataSusbscription = this.catalogService.data$.subscribe((data) => {
      //this.paginator.page.pipe(tap(() => data));
      data.forEach((c: any) => {
        c['pages'] = 0;
        c.fascicles.forEach((f: any) => {
          c['pages'] += Number(f.totalPages);
        });
      });
      this.dataCatalog = this.catalogService.fillDataTable(data);
      this.filteredCatalogs = [...this.dataCatalog];
    });

    //Subscribe to fascicle loading
    this.fascicleSubscription = this.fascicleService.loadingFascicle.subscribe(
      (data) => {
        this.catalogService.fetchCatalogList();
      }
    );

  }

  applyFilter(text: string): void {
    const q = (text || '').toLowerCase();
    this.filteredCatalogs = this.dataCatalog.filter(c =>
      c.name?.toLowerCase().includes(q)
    );
  }

  //Open catalog modal
  //Go to catalog/new
  openCatalog(id: string) {
    this.catalogService.openForm(id);
  }

  //Delete catalog - Ask if sure
  deleteCatalog(event: Event, id: string) {
    this.catalogService.deleteCatalog(id, event);
  }

  //Open new fascicle modal
  newFascicle(catalogId: string) {
    this.fascicleService.newModalFascicle(catalogId);
  }


  goToFascicles(catalogId: string) {
    this.router.navigate(['/catalog', catalogId, 'fascicles']);
  }

  exportCatalog(catalogId: string) {
    this.catalogService.openUploadFormToSyncwall(catalogId);
  }

  configureCatalog(id: string) {
    this.catalogService.openEditForm(id);
  }

  syncCatalog(id: string) {
    this.catalogService.openSyncForm(id);
  }

  exportCsvCatalog(id: string) {
    this.catalogService.checkExportToCSV(id);
  }

  newFascicleAuto(catalogId: string) {
    this.fascicleService.newModalFascicleAuto(catalogId);
  }






}
